import React from "react";
import errorImage from "images/unauth-property.png"
import Storage from "common/localStorage"

const style = {
  container: {
    height: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  contentUnauth: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 106px)",
    border: '1px solid #dadada',
    background: 'white',
    margin: 20,
  },
  content: {
    textAlign: "center"
  },
  heading: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "28px",
    lineHeight: "48px",
    textAlign: "center",
    color: "#333333"
  },
  subHeading: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "20px",
    lineHeight: "30px",
    textAlign: "center",
    color: "rgba(51, 51, 51, 0.75)"
  },
  text: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    color: "rgba(51, 51, 51, 0.75)"
  },
  link: {
    color: "#27bbed"
  }
}

var count = 10;

export default (props) => {
  const linkMyHyly = "https://" + process.env.REACT_APP_MyhylyHost
  const [timer, setTimer] = React.useState(count);
  const [emptyAuth, setEmptyAuth] = React.useState(false);

  React.useEffect(() => {
    count = 10;
    let countDown;
    if (!Storage.getItem("emptyAuth")) {
      countDown = setInterval(async () => {
        if (count == 0) {
          clearInterval(countDown);
          window.open(linkMyHyly, '_blank');
        }
        else {
          count = count - 1;
          await setTimer(count);
        }
      }, 1000)
    } else {
      setEmptyAuth(true);
      Storage.removeItem("emptyAuth");
    }
    return () => { clearInterval(countDown); }
  }, [])

  return (
    <div style={props.unauth ? style.contentUnauth : style.container}>
      <div style={style.content}>
        <img src={errorImage} alt="error" />
        <div style={style.heading}>You do not have access to hyEvents</div>
        {
          !emptyAuth ? <>
            <div style={style.subHeading}>You will be redirected to my.hy.ly in {timer}s</div>
            <div style={style.text}>Or, you may <a style={style.link} href={linkMyHyly} target="_blank">click here</a> to redirect now</div>
          </> : null
        }
      </div>
    </div>
  )
}